<div>
    <br>
    <br>
    <nb-form-field *ngIf="iconCategories" class='icon-dropdown'>
        <nb-select ngDefaultControl [(ngModel)]="selectedCategory" [placeholder]="'icon_category'| translation">
            <nb-option *ngFor="let category of iconCategories" [value]="category">{{category.title}}</nb-option>
        </nb-select>
    </nb-form-field>

    <nb-form-field class='icon-dropdown'>
        <!-- Placeholder until category is selected  -->
        <nb-select *ngIf="!selectedCategory" [disabled]="!selectedCategory" [placeholder]="'icon'| translation">
        </nb-select>

        <nb-select *ngIf="selectedCategory" ngDefaultControl [(ngModel)]="selectedIcon"[placeholder]="'icon'| translation"(selectedChange)="previewCat()">
            <nb-select-label>
                <span [innerHTML]="getIconHtml(selectedIcon)">
        </span>
            </nb-select-label>

            <nb-option *ngFor="let icon of selectedCategory.items" [value]="icon"> <i [ngClass]='icon'></i> </nb-option>
        </nb-select>
    </nb-form-field>

    <nb-form-field>
        <input nbInput [placeholder]="'category_new'| translation" noWhiteSpace #newCatName="ngModel" [(ngModel)]="newCat" (input)="previewCat()">
    </nb-form-field>

</div>
<div style="color:red;" *ngIf="alreadyExists()">{{'model_already_exist'| translation}}.</div>
<div style="color:red;" *ngIf="newCatName.errors && newCatName.errors.noWhiteSpace">{{'model_no_white_space'| translation}}.
</div>


<div *ngIf="newCat && selectedIcon" class="row">
    <br>
    <span>{{'menu_preview'| translation}}:</span>
    <br>
    <div class="col-md-3">
        <nb-menu [items]="previewList" status="primary" autoCollapse="true"></nb-menu>
    </div>
    <br>
    <div>
        <button nbButton status="primary" (click)="createCategory()" [disabled]="alreadyExists() || newCatName.invalid">{{'add'| translation}}</button>
    </div>
</div>